import { useEffect, useState } from "react";

import { setPermanentSession, usePermanentSession } from "modules/Login/hooks";

import type { Session } from "modules/Login/queryKeys";
import type { ReactNode } from "react";

export const PERSISTED_SESSION = "_session";
export const PERSISTED_DEALER_ID = "_dealerId";
export const PERSISTED_LOCATION_ID = "_locationId";

const clearItem = (name: string) => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  sessionStorage.removeItem(name);
};

export const clearAllItemsPersisted = () => {
  clearItem(PERSISTED_SESSION);
  clearItem(PERSISTED_DEALER_ID);
  clearItem(PERSISTED_LOCATION_ID);
};

const getCookie = (name: string) => {
  return document.cookie
    .split(";")
    .find(x => x.includes(`${name}=`))
    ?.trim()
    .replace(`${name}=`, "");
};

export const persistItem = (name: string, value: string, expireAt?: string) => {
  if (expireAt) document.cookie = `${name}=${value}; expires=${new Date(expireAt).toUTCString()}; path=/`;
  else document.cookie = `${name}=${value}; path=/`;

  sessionStorage.setItem(name, value);
};

const getPersistedItem = (name: string) => sessionStorage.getItem(name) || getCookie(name);

export const getPersistedSession = (): Session | null => {
  const persistedSession = getPersistedItem(PERSISTED_SESSION);
  if (persistedSession) {
    try {
      return JSON.parse(decodeURIComponent(persistedSession));
    } catch (error) {
      console.error("Failed to JSON parse the persisted session", error);
    }
  }

  return null;
};

export const PersistanceManager = ({ children }: { children: ReactNode }) => {
  const [isReady, setIsReady] = useState(false);
  const { session } = usePermanentSession();

  useEffect(() => {
    if (!session?.token) {
      const persistedSession = getPersistedSession();
      if (persistedSession) setPermanentSession(persistedSession);
    }

    setIsReady(true);
  }, []);

  return isReady && children;
};
